module.exports = __webpack_public_path__ + "img/Infografis_ID_20.06c9c6ce.jpg";